

export function Document(data: any) {
  return <></>;
}